module.exports = __webpack_public_path__ + "assets/31f4ffdd77ac54759a0f72d17f42ce2d.png";